import React, { useState, useEffect } from 'react';
import emailjs from 'emailjs-com';
import CustomAlert from './CustomAlert'; // Importa la alerta personalizada
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTelegram } from '@fortawesome/free-brands-svg-icons';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const [alert, setAlert] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_ba0ylis', 'template_97jccln', e.target, 'DzbswR4yuOGktuyY4')
      .then(
        (result) => {
          setAlert({ message: '¡Tu mensaje fue enviado correctamente!', type: 'success' });
          // Limpiar el formulario después de enviarlo exitosamente
          setFormData({
            name: '',
            email: '',
            message: '',
          });
        },
        (error) => {
          setAlert({ message: 'Hubo un error al enviar el mensaje. Puedes escribir un correo a hola@framegonz.com', type: 'error' });
        }
      );
  };

  useEffect(() => {
    if (alert) {
      const timer = setTimeout(() => {
        setAlert(null);
      }, 5000); // Se oculta después de 5 segundos
      return () => clearTimeout(timer); // Limpiar el timer si el componente se desmonta
    }
  }, [alert]); // Se ejecuta cada vez que cambia el estado `alert`

  return (
    <section id="contact">
      <br/>
      <h2>Contacto</h2>
      <br/>
      {alert && <CustomAlert message={alert.message} type={alert.type} />}
      <form onSubmit={handleSubmit}>
        <label htmlFor="name">Nombre</label>
        <input
          type="text"
          id="name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
        />
        
        <label htmlFor="email">Correo Electrónico</label>
        <input
          type="email"
          id="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
        />
        
        <label htmlFor="message">Mensaje</label>
        <textarea
          id="message"
          name="message"
          value={formData.message}
          onChange={handleChange}
          required
          rows="4"
        ></textarea>
        
        <button type="submit">Enviar</button>
      </form>
      <br/>
      <label>También puedes escribirme por Telegram</label>
      <br/>
        <a href="https://t.me/framegonz" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faTelegram} className="icon"/></a>
    </section>
  );
};

export default Contact;